import { type Page, typedApi } from "@/api/typed-client";
import { useQuery } from "@tanstack/react-query";

export interface ApiKeySummary {
  id: string;
  name: string;
  key_prefix: string;
  rate_limit_rpm: number | null;
  expires_at: string | null;
  created_at: string;
  last_used_at: string | null;
  revoked_at: string | null;
}

export function useApiKeys(projectId: string | null) {
  return useQuery({
    enabled: !!projectId,
    queryKey: ["api-keys", projectId],
    queryFn: async () => {
      // Note: the list endpoint only supports active_only (no page_size). Pagination intentionally skipped — see plan Batch-6 Phase A.2.
      const { data, error } = await typedApi.GET("/v1/projects/{project_id}/api-keys", {
        params: { path: { project_id: projectId ?? "" } },
      });
      if (error) throw new Error(JSON.stringify(error));
      // Justified: Page_ApiKeySummary_ lacks last_used_at/revoked_at fields in openapi schema
      return data as unknown as Page<ApiKeySummary>;
    },
  });
}
